<template>
  <VaPopover placement="top">
    <VaIcon name="info" :size="14" class="text-neutral-500 cursor-help" />
    <template #body>
      <div class="max-w-xs text-xs leading-relaxed normal-case tracking-normal">{{ text }}</div>
    </template>
  </VaPopover>
</template>

<script lang="ts" setup>
import { VaIcon, VaPopover } from 'vuestic-ui'

defineProps<{
  text: string
}>()
</script>
